/**
 * Settings sub-section picker (AI Controls / Usage / Billing / Maintenance).
 */
import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { Text } from '@/components/ui/text';
import { AdminSectionCard, AdminStatusPill, ADMIN_COLORS } from '@/components/admin/AdminUI';
import { SETTINGS_SECTIONS, settingsSectionDescription } from '../platformAdminFormat';
import type { SettingsSection } from '../platformAdminTypes';

interface SettingsSectionTabsProps {
  settingsSection: SettingsSection;
  onChange: (section: SettingsSection) => void;
}

export default function SettingsSectionTabs({ settingsSection, onChange }: SettingsSectionTabsProps) {
  const activeSettingsDescription = settingsSectionDescription(settingsSection);

  return (
    <AdminSectionCard
      icon="settings"
      title="Settings"
      subtitle={activeSettingsDescription}
      headerRight={<AdminStatusPill label={settingsSection.toUpperCase()} tone="primary" />}
    >
      <View className="flex-row flex-wrap" style={{ gap: 10 }}>
        {SETTINGS_SECTIONS.map((section) => {
          const active = settingsSection === section.key;
          return (
            <TouchableOpacity
              key={section.key}
              onPress={() => onChange(section.key)}
              activeOpacity={0.85}
              style={{
                flexGrow: 1,
                minWidth: 150,
                borderWidth: 1,
                borderColor: active ? ADMIN_COLORS.primary : ADMIN_COLORS.border,
                borderRadius: 14,
                backgroundColor: active ? ADMIN_COLORS.primaryFaint : ADMIN_COLORS.background,
                paddingHorizontal: 14,
                paddingVertical: 12,
                flexDirection: 'row',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <MaterialIcons
                name={section.icon}
                size={18}
                color={active ? ADMIN_COLORS.primary : ADMIN_COLORS.text.secondary}
              />
              <Text
                className="text-sm font-bold"
                style={{ color: active ? ADMIN_COLORS.primary : ADMIN_COLORS.text.secondary }}
              >
                {section.label}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </AdminSectionCard>
  );
}
